import type { HTMLAttributes, ReactNode } from 'react';

type Tone = 'neutral' | 'amber' | 'success' | 'info' | 'danger';

type Props = {
  tone?: Tone;
  children: ReactNode;
} & HTMLAttributes<HTMLSpanElement>;

const tones: Record<Tone, string> = {
  neutral: 'bg-surface-muted text-ink-muted',
  amber: 'bg-warning-bg text-warning',
  success: 'bg-success-bg text-success',
  info: 'bg-info-bg text-info',
  danger: 'bg-danger-bg text-danger',
};

export function Pill({ tone = 'neutral', className = '', children, ...rest }: Props) {
  return (
    <span
      className={[
        'inline-flex items-center rounded-sm px-2.5 py-1 text-[11px] font-medium uppercase tracking-wide',
        tones[tone],
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </span>
  );
}
